import {
    putApiUserPreferencesUserSelectedDatabases,
    postApiUserLoginCallback,
    putApiUserUserConsent,
    getApiUserUserData,
} from "@/generated";
import type { PutApiUserUserConsentData } from "@/generated";

import { handleApiResponse } from "./handleApiResponse";
import { handleApiResponseAssertData } from "./handleApiResponseAssertData";

export const apiUser = {
    setUserSelectedDatabases: async (selectedDatabaseIds: number[]) =>
        handleApiResponse(() =>
            putApiUserPreferencesUserSelectedDatabases({
                body: selectedDatabaseIds,
            }),
        ),
    userLoginCallback: async () => handleApiResponse(postApiUserLoginCallback),
    setUserConsent: async (params: PutApiUserUserConsentData) =>
        handleApiResponse(() => putApiUserUserConsent(params)),
    getUserData: async () => handleApiResponseAssertData(getApiUserUserData),
};
